"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LogEvent {
    constructor(eventName) {
        this.user = null;
        this.value = null;
        this.metadata = null;
        this.eventName = eventName;
        this.statsigMetadata = {};
        this.time = Date.now();
    }
    getName() {
        return this.eventName;
    }
    setValue(value) {
        this.value = value;
    }
    setMetadata(metadata) {
        this.metadata = metadata;
    }
    addStatsigMetadata(key, value) {
        this.statsigMetadata[key] = value;
    }
    setUser(newUser) {
        // Need to remove private attributes from logs and also keep in the original user for evaluations.
        this.user = { ...newUser };
        delete this.user.privateAttributes;
    }
    setSecondaryExposures(exposures = []) {
        this.secondaryExposures = exposures;
    }
    toJsonObject() {
        var _a;
        return {
            eventName: this.eventName,
            user: this.user,
            value: this.value,
            metadata: this.metadata,
            time: this.time,
            statsigMetadata: this.statsigMetadata,
            secondaryExposures: (_a = this.secondaryExposures) !== null && _a !== void 0 ? _a : undefined,
        };
    }
}
exports.default = LogEvent;
